import { useTranslation } from "react-i18next";
import "./WeekdayItem.css";

function WeekdayItem({ dayName, events }) {
  const { t, i18n } = useTranslation();
  if (events == null || events.length < 1) {
    return <></>;
  } else
    return (
      <div className="min-h-8">
        <h4>{dayName}</h4>
        {events.map((e, i) => {
          return (
            <p className="mt-2">
              <span className="underline">{e.dateandlocation}</span>
              <br></br>
              {e.info}
            </p>
          );
        })}
      </div>
    );
}

export default WeekdayItem;
